//Esta clase ordena los datos en estructuras iterables para que sean mas sencillas de consumir e implementar el el frontend
export default class Formats {
    plan_table_format_heads() {
        return {
            heads: ['SEM. SIEMBRA', 'ESTATUS', 'SEM. TRANSPLANTE', 'FLOR', 'VARIEDAD', 'COLOR',
                'DENSIDAD', 'CICLO PROPAGACIÓN', 'CICLO CAMPO', 'SEM. COSECHA', 'M2 NECESARIOS',
                'PLANTAS', '% RECUP', 'TALLOS COSECHADOS', 'CAMAS', 'CAVIDAD',
                'GERMINACIÓN', 'CHAROLAS', 'SEMILLAS'],
            blocks: []


        }
    }
}